import styles from './QCHeader.module.css';

export interface QCHeaderProps {
  hasUnsavedChanges?: boolean;
}

/**
 * QCHeader - Branding-only header for Quality Check Workflow
 * - Enlarged BAM logo linking back to Data Quality overview
 * - Optional unsaved changes reminder below the mark
 */
export function QCHeader({ hasUnsavedChanges = false }: QCHeaderProps) {
  return (
    <header className={styles.header}>
      <a
        href="#data-quality"
        className={styles.logoLink}
        aria-label="Return to Data Quality overview"
      >
        <img
          src="/BAM-logo-embedded.svg"
          alt="Book Award Mastery logo"
          className={styles.logo}
        />
      </a>
      {hasUnsavedChanges && (
        <p className={styles.unsavedWarning} role="status">
          ⚠️ Unsaved changes
        </p>
      )}
    </header>
  );
}

export default QCHeader;
